import { platformSearch } from 'api/platformRequest';
import React, { useState, useEffect } from 'react';
import { MdSearch } from 'react-icons/md';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import './style.css';
import Button from 'ReusableComponents/Button';
import { DESIGN_CONFIG, STRING_CONFIG } from 'utils';
import { storePlatformSearchInputValue } from 'store/platform/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useAdTray } from 'contexts/AdTrayContext';
import WhiteStartSearchModal from 'asset/icon/filled/white-start-search-modal.svg';
import SearchSmallBack from 'asset/icon/outlined/search-small-back.svg';
import Box from 'ReusableComponents/Box';
import Text from 'ReusableComponents/Text';
import { LuSearch } from 'react-icons/lu';
import { fetchSearchResults } from 'Pages/Product/Topbar/SearchInput';
import { Helmet } from 'react-helmet';
import { formatNumberAsRepresentation } from 'helpers';

function MSearch() {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const inputValueFromStore = useSelector(
    (state) => state.platform.platformSearchInputValue
  );

  const history = useHistory();

  const [suggestions, setSuggestions] = useState([]);

  const [isFocused, setIsFocused] = useState(false);

  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);

  const { setShowAdTray } = useAdTray();

  useEffect(() => {
    setShowAdTray(false);
  }, []);

  useEffect(() => {
    fetchSearchResults(
      inputValueFromStore,
      platformSearch,
      setSuggestions,
      (error) => console.error(error),
      setIsLoading
    );
  }, [inputValueFromStore]);

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();

      setSelectedSuggestionIndex((prevIndex) => {
        const nextIndex =
          prevIndex < suggestions.length - 1 ? prevIndex + 1 : 0;
        return nextIndex;
      });
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();

      setSelectedSuggestionIndex((prevIndex) => {
        const nextIndex =
          prevIndex > 0 ? prevIndex - 1 : suggestions.length - 1;
        return nextIndex;
      });
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (
        selectedSuggestionIndex >= 0 &&
        selectedSuggestionIndex < suggestions.length
      ) {
        const selectedProduct = suggestions[selectedSuggestionIndex];

        history.push(
          selectedProduct?.url_slug
            ? `/product/${selectedProduct.code}/${selectedProduct.url_slug}`
            : `/product/${selectedProduct.code}`
        );

      } else if (
        inputValueFromStore.trim() !== '' &&
        inputValueFromStore.length > 2
      ) {
        dispatch(storePlatformSearchInputValue(inputValueFromStore));

        history.push(`/search/${inputValueFromStore}`);
      }
    }
  };

  useEffect(() => {
    setSelectedSuggestionIndex(-1);
  }, [suggestions]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          gap: '1rem',
          position: 'relative',
          padding: '.75rem 1.5rem',
        }}
      >
        <Button
          alignItems='center'
          aria-label='back'
          border='none'
          display='flex'
          onClick={() => history.goBack()}
          padding={0}
        >
          <img alt='search' height={24} src={SearchSmallBack} width={24} />
        </Button>
        <div
          className={`search-input-small ${isFocused ? 'focused' : null}`}
          role='search'
        >
          <input
            aria-autocomplete='list'
            aria-label='Search Input'
            aria-owns={suggestions?.length > 0 ? 'suggestions-list' : null}
            onBlur={() => setIsFocused(false)}
            onChange={(e) => {
              dispatch(storePlatformSearchInputValue(e.target.value));
            }}
            onFocus={() => setIsFocused(true)}
            onKeyDown={handleKeyDown}
            placeholder={STRING_CONFIG.inPage.common.lnkNavBarSearch}
            type='text'
            value={inputValueFromStore}
          />
          <MdSearch
            color={
              isFocused
                ? DESIGN_CONFIG.color.primary.primaryMain
                : DESIGN_CONFIG.color.text.text200
            }
            size={24}
          />
        </div>
      </div>
      {inputValueFromStore.length >= 3 &&
        suggestions?.length === 0 &&
        !isLoading && (
          <ul className='suggestions-small'>
            <Box display='flex' justifyContent='center'>
              <Box
                alignItems='center'
                display='flex'
                flexDirection='column'
                gap='.5rem'
                margin='1.5rem 0'
              >
                <LuSearch color={DESIGN_CONFIG.color.text.text500} size={24} />
                <Text
                  color={DESIGN_CONFIG.color.text.text500}
                  fontSize={
                    DESIGN_CONFIG.typography.section.webSectionTitle.fontSize
                  }
                  fontWeight={
                    DESIGN_CONFIG.typography.section.webSectionTitle.fontWeight
                  }
                  m='0'
                >
                  {`${STRING_CONFIG.inPage.platformSearch.txtNoResultsFor} '${inputValueFromStore}' ${STRING_CONFIG.inPage.platformSearch.txtOtherKeyword}`}
                </Text>
              </Box>
            </Box>
          </ul>
        )}
      {isFocused && inputValueFromStore && suggestions?.length > 0 && (
        <ul className='suggestions-small' id='suggestions-list' role='listbox'>
          {suggestions.slice(0, 5).map((result, index) => (
            <li
              aria-selected={
                selectedSuggestionIndex === index ? 'true' : 'false'
              }
              className={`list-item ${selectedSuggestionIndex === index ? 'selected' : null}`}
              key={result?.code}
              onMouseDown={(event) => {
                event.preventDefault();

                history.push(
                  result?.url_slug
                    ? `/product/${result.code}/${result.url_slug}`
                    : `/product/${result.code}`
                );
              }}
              role='option'
            >
              <img alt='' className='image' src={result?.image} />
              <div className='product-details'>
                <p
                  style={{
                    color: `${DESIGN_CONFIG.color.text.text500}`,
                    fontSize: '.875rem',
                    fontWeight: 400,
                    margin: 0,
                  }}
                >
                  {result?.model} {result?.variant}
                </p>
                <p
                  style={{
                    color: `${DESIGN_CONFIG.color.text.text100}`,
                    fontSize: '.75rem',
                    fontWeight: 400,
                    margin: 0,
                  }}
                >
                  {result?.brand}
                </p>
                <div
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    gap: '.5rem',
                  }}
                >
                  <div
                    style={{
                      background: `${DESIGN_CONFIG.color.primary.primaryMain}`,
                      display: 'flex',
                      gap: '.25rem',
                      padding: '.25rem',
                    }}
                  >
                    <img
                      alt=''
                      height={20}
                      src={WhiteStartSearchModal}
                      width={12}
                    />
                    <p
                      style={{
                        color: `${DESIGN_CONFIG.color.neutral.neutral500}`,
                        fontSize: '.75rem',
                        fontWeight: 500,
                        margin: 0,
                      }}
                    >
                      {result?.value === 0 || result?.value == null
                        ? '--'
                        : result?.value}
                    </p>
                  </div>
                  <p
                    style={{
                      color: `${DESIGN_CONFIG.color.text.text100}`,
                      fontSize: '.75rem',
                      fontWeight: 400,
                      margin: 0,
                    }}
                  >
                    {formatNumberAsRepresentation(result?.total_review)}
                  </p>
                </div>
              </div>
            </li>
          ))}
          {suggestions.length > 5 && (
            <Button
              aria-selected={
                selectedSuggestionIndex === suggestions.length
                  ? 'true'
                  : 'false'
              }
              background={DESIGN_CONFIG.color.neutral.neutral500}
              border={`1px solid ${DESIGN_CONFIG.color.neutral.neutral100}`}
              borderRadius='4px'
              cursor='pointer'
              fontSize={DESIGN_CONFIG.typography.common.webButton.fontSize}
              fontWeight={DESIGN_CONFIG.typography.common.webButton.fontWeight}
              marginTop='.5rem'
              onMouseDown={(event) => {
                event.preventDefault();

                history.push(`/search/${inputValueFromStore}`);
              }}
              padding='1rem'
              textColor={DESIGN_CONFIG.color.text.text500}
              w='100%'
            >
              {STRING_CONFIG.inPage.platform.btnViewAllSearchResults}
            </Button>
          )}
        </ul>
      )}
      <Helmet>
        <title>{STRING_CONFIG.inPage.tabTitle.platformSearch}</title>
        <meta
          name='description'
          content="Quickly find the products you want and get accurate results with your AI shopping assistant."
        />
        <meta name='keywords' content='Product, Reviews, Genuine Reviews' />
      </Helmet>
    </>
  );
}

export default MSearch;
